import {
  GET_SINISTRES,
  GET_SINISTRES_FAILED,
  GET_SINISTRE_DETAILS,
  GET_SINISTRE_DETAILS_FAILED,
  SET_SINISTRES,
  SET_SINISTRE_DETAILS,
  SET_REFUNDS_AMC,
  GET_REFUNDS_AMC,
  GET_REFUNDS_AMC_FAILED,
  SET_REFUND_AMC_DETAILS,
  GET_REFUND_AMC_DETAILS,
  GET_REFUND_AMC_DETAILS_FAILED,
} from 'store/sinistre/constants';
import {
  getSinistreType,
  setSinistreType,
  GetSinistreFailedType,
  setSinistreDetailsType,
  getSinistreDetailsType,
  GetSinistreDetailsFailedType,
  SetRefundsAMCType,
  GetRefundsAMCType,
  GetRefundsAMCTypeFailedType,
  GetRefundAMCDetailsType,
  SetRefundAMCDetailsType,
  GetRefundAMCDetailsFailedType,
} from 'store/sinistre/types';

export const getSinistres = (): getSinistreType => ({
  type: GET_SINISTRES,
});

export const setSinistres = (payload: any[]): setSinistreType => ({
  type: SET_SINISTRES,
  payload,
});

export const getSinistresFailed = (): GetSinistreFailedType => ({
  type: GET_SINISTRES_FAILED,
});

export const getSinistreDetails = (
  claimNumber: string,
): getSinistreDetailsType => ({
  type: GET_SINISTRE_DETAILS,
  claimNumber,
});

export const setSinistreDetails = (
  payload:
    | {
        title: string;
        subtitle: string;
        actualDate: any;
        timelineState: string;
        shareName: string;
        status: string;
        description: string;
      }[]
    | [],
): setSinistreDetailsType => ({
  type: SET_SINISTRE_DETAILS,
  payload,
});

export const getSinistreDetailsFailed = (): GetSinistreDetailsFailedType => ({
  type: GET_SINISTRE_DETAILS_FAILED,
});

export const getRefundsAMC = (payload: any): GetRefundsAMCType => ({
  type: GET_REFUNDS_AMC,
  payload,
});

export const setRefundsAMC = (payload: any): SetRefundsAMCType => ({
  type: SET_REFUNDS_AMC,
  payload,
});

export const getRefundsAMCFailed = (
  payload: string,
): GetRefundsAMCTypeFailedType => ({
  type: GET_REFUNDS_AMC_FAILED,
  payload,
});

export const getRefundAMCDetails = (payload: {
  refundNumber: string;
  policyNumber: string;
}): GetRefundAMCDetailsType => ({
  type: GET_REFUND_AMC_DETAILS,
  payload,
});

export const setRefundAMCDetails = (payload: any): SetRefundAMCDetailsType => ({
  type: SET_REFUND_AMC_DETAILS,
  payload,
});

export const getRefundAMCDetailsFailed = (
  payload: string,
): GetRefundAMCDetailsFailedType => ({
  type: GET_REFUND_AMC_DETAILS_FAILED,
  payload,
});
